import React, { useContext } from "react";
import { useSession, signIn } from "next-auth/react";
export const AuthContext = /*#__PURE__*/ React.createContext({
    useSession,
    useUser,
    refreshSession,
    signIn
});
export const useAuth = ()=>{
    return useContext(AuthContext);
};
function useUser() {
    const { data: session  } = useSession();
    if (!(session === null || session === void 0 ? void 0 : session.user)) throw new Error("User not present in session.");
    return session.user;
}
function refreshSession() {
    document.dispatchEvent(new Event("visibilitychange"));
}
